<script>

import PasswordField from './sub/PasswordField.svelte'
import UploadProgress from './sub/UploadProgress.svelte'


// form bindings
let file_password = ''
let file_note = ''
let files_list

let file
$: file = files_list ? files_list[0] : null

let is_valid
$: is_valid = file?.name && (file_password.length >= 8)

let upload_progress = null

let complete = null

const process_form = async () => {
    if (!is_valid) {
        return
    }

    const result = await tx.file_upload(file, file_password, file_note, e => {
        upload_progress = e
    })

    console.log(result)
    complete = result

}

let size_limit = null
const get_limit = async () => {
    let body = await fetch('/api/info/size_limit', {credentials: 'include'})
    body = await body.json()
    if (body.ok) {
        size_limit = body.limit
        return body.limit
    }
    return '?'
}

</script>

<div class="page_container">
    <h1 class="title">Upload new file</h1>
    <h2 class="subtitle">
        {#await get_limit()}
            Checking your quota...
        {:then limit}
            {limit} limit.
        {:catch}
            Limit check failed.
        {/await}
    </h2>

    <div class="box block">

    
        <form on:submit={process_form}>
            <div class="field">
                <label for="fileinput" class="label">File</label>
                <div class="control">
                    <input 
                        class="input"
                        type="file"
                        name="file"
                        bind:files={files_list}
                        id="fileinput">
                </div>
                
            </div>
            
            <div class="field">
                <label class="label" for="file_note">Note</label>
                <div class="control">
                    <input
                            class="input"
                            type="text"
                            bind:value={file_note}
                            id="file_note"
                            placeholder="(optional) additional information">
                </div>
            </div>

            <PasswordField
                label="Password"
                bind:value={file_password}
                id="file_password"
                placeholder="file encryption password"/>

        </form>
        <br/>

        <div class="level">
            <div class="level-left">
                {#if !file}
                    <span>upload a file to get started</span>
                {:else if file_password.length < 8}
                    <span class="has-text-danger">please pick a longer password</span>
                {:else if upload_progress === null}
                    <span class="has-text-success">ready to upload</span>
                {:else if complete?.ok}
                    <span class="has-text-success">upload complete!</span>
                {:else}
                    <span class="has-text-success">uploading...</span>
                {/if}
            </div>
            <div class="level-right">
                {#if complete?.ok}
                    <button
                        class="button"
                        disabled="disabled">
                        complete
                    </button>
                {:else}
                    <button
                        class="button {upload_progress === null ? '' : 'is-loading' }"
                        disabled={!is_valid}
                        on:click={process_form}>
                        {#if is_valid}
                            <span>Ready to go</span>
                            <span class="icon">
                                <i class="fas fa-upload"></i>
                            </span>
                            
                        {:else}
                            Not ready
                        {/if}
                    </button>
                {/if}
            </div>
        </div>
    </div>
    
    <UploadProgress progress={upload_progress}/>

    {#if complete?.ok}
        <div class="box block has-background-success">
            <div class="level">
                <div class="level-left">
                    <span>File link available.</span>
                </div>
                <div class="level-right">
                    <a href="/download/{complete.id.replace('file_', '')}" class="button">
                        <span>View</span>
                        <span class="icon">
                            <i class="fas fa-arrow-right"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        
    {/if}
</div>
